import { IconMapCar16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';
import { UIText2 } from '@cian/ui-kit/typography';
import * as React from 'react';
import { TTransportType } from '../../../types/newbuildingRecommendations';

import * as styles from './GeoTravelTime.css';

interface IGeoTravelTimeProps {
  transportType: TTransportType;
  distance: string;
}

export const GeoTravelTime: React.FC<IGeoTravelTimeProps> = ({ transportType, distance }) => {
  const Icon = transportType === 'walk' ? IconMapWalk16 : IconMapCar16;

  return (
    <div className={styles['container']}>
      <div data-name={transportType} className={styles['icon']}>
        <Icon display="block" color="icon-secondary-default" />
      </div>

      <UIText2 display="inline" color="text-secondary-default">
        {distance}
      </UIText2>
    </div>
  );
};
